<template>
  <section class="flex w-fit gap-3 items-center">
    <button
      v-if="showPlayButton"
      class="btn-simple flex gap-1 items-start"
      v-tooltip="`Desligar áudio`"
      @click="playAudio()"
    >
      <v-icon v-if="audioON" name="md-volumeup-round" :scale="scaleIcons" />
      <v-icon v-if="!audioON" name="md-volumeoff" :scale="scaleIcons" />
      <p class="hidden md:flex" v-if="showIconsName">
        {{ audioON ? "Áudio ligado" : "Áudio desligado" }}
      </p>
    </button>

    <div class="z-50" v-if="showSpeedButton">
      <div
        ref="speedOptions"
        v-if="speedOptions"
        class="w-32 h-28 bg-white absolute -mt-12 ml-8 shadow-md rounded-md"
        v-motion-pop
      >
        <Button
          v-for="(speed, index) in speeds"
          :key="index"
          class="w-full btn-simple h-7"
          @click="speedUp(speed.value)"
          >{{ speed.name }}</Button
        >
      </div>
      <button
        class="btn-simple flex gap-2"
        @click="openSpeedUpOptions"
        v-tooltip="`Velocidade: ${getSpeedName()}`"
      >
        <v-icon name="md-slowmotionvideo" :scale="scaleIcons" />
        <p class="hidden md:flex" v-if="showIconsName">
          {{ $t("labels.generic", { pt: "Repetir", en: "Repeat" }) }}
        </p>
      </button>
    </div>
    <button
      v-if="showRepeatButton"
      class="btn-simple flex gap-1 items-start"
      v-tooltip="`Repetir áudio`"
      @click="repeatAudio()"
    >
      <v-icon name="md-replay" :scale="scaleIcons" />
      <p class="hidden md:flex" v-if="showIconsName">
        {{ $t("labels.generic", { pt: "Repetir", en: "Repeat" }) }}
      </p>
    </button>
  </section>
</template>

<script lang="ts">
import { getItemStorage, setItemStorage } from "@/utils/save-storage.util";
import { defineComponent } from "vue";
import { Speeds } from "./message-voice.utils";
import { MessageVoiceService } from "./message-voices.service";
export default defineComponent({
  name: "messageVoice",
  emits: ["onEndMessage"],
  data() {
    return {
      audioON: false as boolean,
      currentSpeed: 1.2 as number,
      speeds: [] as any,
      speedOptions: false as boolean,
      isOnSpeed: false as boolean,
    };
  },
  props: {
    msg: {
      type: String,
      default: "intro",
    },
    showIconsName: {
      type: Boolean,
      default: false,
    },
    showRepeatButton: {
      type: Boolean,
      default: true,
    },
    showSpeedButton: {
      type: Boolean,
      default: true,
    },
    showPlayButton: {
      type: Boolean,
      default: true,
    },
    autoPlay: {
      type: Boolean,
      default: true,
    },
    scaleIcons: {
      type: Number,
      default: 1,
    },
  },
  computed: {
    chatbotService(): MessageVoiceService {
      return new MessageVoiceService();
    },
  },
  beforeMount() {
    this.pauseAudio();
  },
  mounted() {
    this.speeds = Speeds;
    this.startMessage();
  },
  unmounted() {
    this.pauseAudio();
  },
  methods: {
    playAudio(): void {
      this.audioON = !this.audioON;
      this.audioON ? this.repeatAudio() : this.pauseAudio();
      setItemStorage("audioON", this.audioON.toString());
    },
    repeatAudio(): void {
      if (this.audioON) {
        const result: SpeechSynthesisUtterance | any =
          this.chatbotService.stopTextToSpeech(this.msg, this.currentSpeed);
        result.onend = (event) => {
          if (!this.isOnSpeed) {
            this.$emit("onEndMessage", event);
          }
          setTimeout(() => {
            this.isOnSpeed = false;
          }, 200);
        };
      }
    },
    pauseAudio(): void {
      this.chatbotService.pauseTextToSpeech();
    },
    speedUp(rate: any): void {
      this.isOnSpeed = true;
      this.currentSpeed = this.getSpeed(rate);
      setItemStorage("audioSpeed", this.currentSpeed.toString());
      this.repeatAudio();
      document.removeEventListener("click", this.closeSpeedUpOptions);
      this.speedOptions = false;
    },
    openSpeedUpOptions(): void {
      if (!this.speedOptions) {
        this.speedOptions = true;
        setTimeout(() => {
          document.addEventListener("click", this.closeSpeedUpOptions);
        }, 100);
      }
    },
    startMessage(): void {
      if (getItemStorage("audioON")) {
        this.audioON = getItemStorage("audioON") === "true" ? true : false;
        this.currentSpeed = Number(getItemStorage("audioSpeed"));
        if (!this.audioON) this.$emit("onEndMessage");
      } else {
        setItemStorage("audioON", "true");
        setItemStorage("audioSpeed", this.currentSpeed.toString());
        this.audioON = true;
      }
      if (this.autoPlay && this.audioON) {
        this.repeatAudio();
      }
    },
    closeSpeedUpOptions(event): void {
      const myDiv = this.$refs.speedOptions as HTMLElement;
      if (myDiv && !myDiv.contains(event.target as Node)) {
        this.speedOptions = false;
        document.removeEventListener("click", this.closeSpeedUpOptions);
      }
    },
    getSpeedName(): string {
      const speed = Speeds.find((speed) => speed.value === this.currentSpeed);
      return speed ? speed.name : "";
    },
    isWindows(): boolean {
      return navigator.userAgent.indexOf("Win") > -1;
    },
    getSpeed(rate: number): number {
      const speed: any = Speeds.find((speed) => speed.value === rate);
      return this.isWindows() ? speed.valueWindows : speed.value;
    },
  },
});
</script>
